import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { mergeMenuPathsWithPermitted } from "../helpers/allowedPermitPathsHelper";
import { debugLogPages } from "../helpers/debugHelper";

const PrivateRoute7 = ({ children }) => {
  debugLogPages(':: PrivateRoute7');
  const location = useLocation();

  const { isUserAuthenticated } = useSelector((state) => state.auth);
  const { menuPaths, isLoadingMenuPaths, isReLoadingMenuFromUrl } = useSelector((state) => state.menu);
  const currentLocation = location.pathname;

  if (!isUserAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  let menuPathsLocal = mergeMenuPathsWithPermitted(menuPaths);

  // Durante carga inicial post-login aún no hay paths del server.
  if (isUserAuthenticated && isLoadingMenuPaths && !isReLoadingMenuFromUrl) {
    menuPathsLocal = mergeMenuPathsWithPermitted([]);
  }

  let hasMenuAccess = false;

  if (currentLocation && menuPathsLocal.length > 0) {
    for (const menuPath of menuPathsLocal) {
      if (currentLocation.startsWith(menuPath)) {
        hasMenuAccess = true;
      }
    }
  }

  if (!hasMenuAccess) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default PrivateRoute7;
